import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Input } from '@playcastdotio/Shadcn';
import { isIOS, isSafari } from '../../api/utility';
import { hostConnectionState, invitationState } from '../../api/stores';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import { faEnvelopes } from '@fortawesome/pro-solid-svg-icons';
import config from '../../config.json';

export const Ios = () => {
  const [invite, setInvite] = useState<string>('');
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const persistentIdFromUrl = searchParams.get('id');

  const handleJoin = () => {
    const inviteCode = invite.split('/').pop();
    const url = `/j/${inviteCode}${persistentIdFromUrl ? `?id=${persistentIdFromUrl}` : ''}`;
    navigate(url);
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setInvite(text);
    } catch (err) {
      console.error('Failed to read clipboard contents: ', err);
    }
  };

  const handleMailTo = () => {
    window.location.href = 'mailto:support@playcast.io';
  };

  return (
    <div className='w-full h-auto m-0 p-0 bg-hero bg-cover bg-no-repeat bg-content text-content-text'>
      <div className='container mx-auto w-full h-dvh py-10 px-8'>
        <section id='hero' className='grid grid-cols-12 gap-y-8 gap-x-4'>
          <div className='col-span-full flex flex-row flex-grow align-middle justify-center gap-x-2 pt-3 items-center'>
            <img src='/images/playcast_logo-96x96.png' alt='Logo' className='w-12 h-12' />
            <h1 className='md:pt-2 text-content-text-headline text-3xl font-bold font-headline'>
              <Link to='/'>Playcast</Link>
            </h1>
          </div>

          {/* @ts-expect-error: Property 'standalone' does not exist on type 'Navigator' */}
          {!window.navigator.standalone ? (
            <div className='justify-items-center col-span-10 col-start-2 lg:col-span-8 lg:col-start-3 grid grid-rows mt-8 mx-auto p-6 bg-footer rounded-lg shadow-md gap-y-4'>
              <h3 className='text-center row-auto font-bold text-2xl'>
                {isIOS() ? 'Add to Home Screen' : "You don't appear to be using IOS."}
              </h3>
              <p className='text-center row-auto'>
                {isIOS() ? "From safari's share menu" : 'You wont need this page. simply click a join link and have fun!'}
              </p>
              {isIOS() && (
                <span className='flex gap-x-1 mt-2'>
                  Tap{' '}
                  <svg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'>
                    <path d='M0 0h24v24H0V0z' fill='none' />
                    <path
                      fill='white'
                      d='M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2z'
                    />
                  </svg>
                  then "Add to home screen"{' '}
                </span>
              )}
            </div>
          ) : (
            <div className='col-span-full grid grid-rows content-center gap-y-2 lg:gap-y-8 justify-center text-center mx-auto'>
              <p className='row-auto text-lg italic my-0 mx-auto'>Paste your session invite link here</p>
              {/* <h2 className='row-auto -mt-4 font-bold text-2xl lg:text-3xl'>{invitationState.currentState.selectedInvite?.description}</h2> */}
              {/* {hostConnectionState.currentState.status === 'disconnected' && <>Host disconnected. Please try again later.</>} */}
              <div className='row-auto w-full gap-2'>
                <Input
                  value={invite}
                  onChange={(e) => setInvite(e.target.value)}
                  type='text'
                  id='inviteCode'
                  name='inviteCode'
                  required
                  placeholder='Invite link'
                  className='w-full h-auto rounded border-none shadow-sm py-3 px-4 mb-2 bg-content text-center text-lg'
                />
                <Button type='button' className='rounded-full' onClick={handleJoin}>
                  Connect to Playcast
                </Button>
              </div>
              <div className='flex flex-col p-6 bg-gray-800 rounded-lg gap-y-4 mt-16'>
                <h3 className='text-center row-auto font-semibold text-xl '>Need Support?</h3>
                <p>Join the discord, submit a bug ticket, or email us directly at support@playcast.io</p>
              </div>
              <div className='flex items-center justify-center gap-x-8 m-4'>
                <Link to={config.DISCORD_URL}>
                  <div className='bg-gray-700 w-fit p-1 flex items-center rounded-lg'>
                    <FontAwesomeIcon icon={faDiscord} className='text-yellow-400 h-8 w-8' />
                  </div>
                </Link>
                <Button size='icon' className='bg-gray-700 focus:bg-gray-700 hover:bg-gray-700 active:bg-gray-700' onClick={handleMailTo}>
                  <FontAwesomeIcon icon={faEnvelopes} className='text-yellow-400 h-8 w-8' />
                </Button>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};
